export default __webpack_public_path__ + "static/media/august.fc2b0ec0.jpg";